module.exports = __webpack_public_path__ + "img/petstairs14.d7afda45.jpg";